const skills = [
  {
    title: "Languages",
    data: ["JavaScript", "TypeScript", "Python", "Java", "C", "C++", "HTML/CSS", "SQL"],
  },
  {
    title: "Frameworks & Libraries",
    data: ["React.js", "Vue.js", "Next.js", "Spring Boot", "Node.js", "Express.js", "GraphQL", "FastAPI", "Tailwind CSS", "Redux"],
  },
  {
    title: "Tools & Platforms",
    data: ["Docker", "Git", "AWS", "GCP", "Jest", "Playwright", "Puppeteer", "Figma", "Sanity.io"],
  },
];

export default skills;
